import { handleActions } from "redux-actions";
import { combineReducers } from "redux";
import {
  addUsers,
  getUsers,
  getUsersSuccess,
  getUsersFailure,
  getUsersIdle,
  getCurrentUser,
  getCurrentUserFailure,
  getCurrentUserIdle,
  getCurrentUserSuccess,
  addUser,
  updateUser,
} from "./actions";
import { Status, initialState, User, initialCurrentState } from "./types";
import _ from "lodash";

const status = handleActions<Status>(
  {
    [getUsers as any]: () => "LOADING",
    [getUsersSuccess as any]: () => "SUCCESS",
    [getUsersFailure as any]: () => "FAILURE",
    [getUsersIdle as any]: () => "IDLE",
  },
  initialState.status
);

const statusCurrent = handleActions<Status>(
  {
    [getCurrentUser as any]: () => "LOADING",
    [getCurrentUserSuccess as any]: () => "SUCCESS",
    [getCurrentUserFailure as any]: () => "FAILURE",
    [getCurrentUserIdle as any]: () => "IDLE",
  },
  initialCurrentState.status
);

const current = handleActions<User>(
  {
    [getCurrentUserSuccess as any]: (state, action) => action.payload,
  },
  initialCurrentState.current
);

const items = handleActions<Record<string, User>>(
  {
    [getUsersSuccess as any]: (state, action) => {
      return { ...state, ...action.payload };
    },
    [addUsers as any]: (state, action: { payload: any }) => {
      let objectToReturn = {};
      if (action.payload.length > 0) {
        _.uniqWith(action.payload, _.isEqual).forEach((item: string) => {
          item = item.toLowerCase().trim();
          let check = false;
          Object.keys(state).forEach((key) => {
            if (key === item) {
              check = true;
            }
          });
          if (!check) {
            objectToReturn = { ...objectToReturn, [item]: null };
          }
        });
      }
      return { ...state, ...objectToReturn };
    },
    [addUser as any]: (state, action: { payload: Partial<User> }) => {
      let objectToReturn = {};
      if (action.payload.Email) {
        objectToReturn = { [action.payload.Email]: action.payload };
      }
      return { ...state, ...objectToReturn };
    }
  },
  initialState.data
);

export const users = combineReducers({
  items,
  status,
  statusCurrent,
  current,
});
